module.exports = __webpack_public_path__ + "img/xiaozi_caixiao.97ad08bd.svg";